import React from 'react'
import { PieChart, Pie, Cell, Tooltip } from 'recharts'

export default function DonutCard({ title, data, size = 160 }) {
  const radius = size / 2

  return (
    <div className="w-full h-full rounded-2xl border border-border-lines p-4">
      <p className="text-base font-semibold text-dark-blue mb-3">{title}</p>

      <div className="flex flex-col items-center gap-4">
        <PieChart width={size} height={size}>
          <Pie
            data={data}
            dataKey="percent"
            nameKey="label"
            cx={radius}
            cy={radius}
            innerRadius={radius * 0.7}
            outerRadius={radius}
            paddingAngle={2}
            stroke="none"
            isAnimationActive={false}
          >
            {data.map((entry) => <Cell key={entry.label} fill={entry.color} />)}
          </Pie>
          <Tooltip formatter={(value) => `${value}%`} />
        </PieChart>

        <div className="w-full flex flex-col gap-2">
          {
            data.map((entry) => (
              <div key={entry.label} className="flex items-center justify-between gap-2 text-sm">
                <span className="flex items-center gap-2 text-secondary">
                  <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: entry.color }} />
                  {entry.label}
                </span>
                <span className="text-dark-blue font-medium">{entry.percent}%</span>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}
